import { DetailWithIcon } from "@/components/ResourceWithIcon.tsx";
import { extractServiceOs } from "@/modules/services/os/serviceOs.ts";
import { useServiceOs } from "@/modules/services/os/useServiceOs.ts";
import { ServiceImageIcon } from "@/modules/services/ServiceImageIcon.tsx";
import type { ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";

export function ServiceOsInfo({ obj }: { obj: ManagedServiceLoc }) {
    const { os, title } = useServiceOs(extractServiceOs(obj));

    return (
        <DetailWithIcon title={title} icon={<ServiceImageIcon image={os} className="color-primary size-0.75rem" />} />
    );
}
